import React,{useState,useEffect, useCallback} from 'react';
import { useSelector } from 'react-redux';
import Button from 'react-bootstrap/Button';

import Products from '../../../../api/Products';

import { authUserHasModuleAccess } from '../../../../utils/auth';
import usePrevious from '../../../../components/common/CustomHooks'
import "./Categories.scss";

const MANAGER_SEARCH_OVERRIDES_MODULE_ID = 340;

export const Categories = ({firstCat=true, handleSearch, handleCategoryClick, handleCheckmark, ...props}) => {

    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [defaultCategories, setDefaultCategories] = useState([]);
    const [activeCategory,setActiveCategory] = useState(useSelector(state => state.pos[props.register_id].category));
    const [showSearch, setShowSearch]=useState(false);
    const [showManagerSettings, setShowManagerSettings]=useState(false);
    const [userPermissions, setUserPermissions]=useState();
    const oldActiveCategory = usePrevious(activeCategory);


    const categoryClickHandler = useCallback(async(id, subcategory=false, defaults=null, newCats=null) =>{
        let localCats
        if(newCats) localCats = newCats; //this should only be on initial load
        else localCats = categories;
        if (!id){ //all categories click (when there are extra categories).  
            // handleCategoryClick(0)
            if(defaults){
                setCategories(defaults); // should only be on initial load
                handleCategoryClick(defaults?.map((item)=>item.id) || 0)
            }
            else {
                setCategories(defaultCategories);
                handleCategoryClick(defaultCategories?.map((item)=>item?.id) || 0)
            }
            setActiveCategory()
            // setSubCategories([]);
        } else if (id !==oldActiveCategory && !subcategory){ //if no category is active or changing categories and we haven't clicked on a subcategory
            handleCategoryClick(id)
            setActiveCategory(id);
            let subcats=[];
            if (localCats?.filter(a=>a.id===id)?.[0]?.parent) subcats=[];
            const response = await Products.Categories.get({id});
            if (response.data?.[0]?.children){
                subcats.push(...response.data[0].children.filter(child=>child.add_on_only===0))
            }
            setSubCategories(subcats);
        }else if (id !==oldActiveCategory && subcategory){ //if it's a subcategory and we just need to load it
            handleCategoryClick(id)
            setActiveCategory(id);
        }
        // else if(id === oldActiveCategory && !subcategory){ //closes the sub categories if they're open
        //     setSubCategories([])
        //     setActiveCategory();
        //     handleCategoryClick(0)
        // }
    },[defaultCategories,categories, oldActiveCategory, handleCategoryClick])

	useEffect(() => {
        const _getCategories = async () => {
            if (props.category_id){
                let categories = props.category_id;
                if (!Array.isArray(props.category_id)) categories=[props.category_id];
                let newCategories = []
                for(let each in categories){
                    const res = await Products.Categories.get({id:categories[each]});
                    if (res.data?.[0]?.children){
                        res.data[0].children.forEach((_, i) => {
                            res.data[0].children[i].parent = true;
                        });
                    }
                    newCategories.push(res.data[0])
                }
                setDefaultCategories(newCategories);
                setCategories(newCategories);
                categoryClickHandler(newCategories[0]?.id, false, newCategories, newCategories) //make the first category the one that loads subcategories
            }
        }

        if (props.category_id) _getCategories();
        //eslint-disable-next-line 
	}, [props.category_id]);

    useEffect(()=>{

        const checkPermission=async()=>{
            let response = await authUserHasModuleAccess(MANAGER_SEARCH_OVERRIDES_MODULE_ID);
            setUserPermissions(response);
        }

        checkPermission();

        return ()=>{
            setCategories([]);
            setSubCategories([]);
            setDefaultCategories([]);
        }
    },[]);

    return (
        <>
            <div className="category-buttons">
                <Button as="a" size="sm" onClick={()=>setShowSearch(!showSearch)} className="btn-category search-btn" >
                    <span>
                        <i className="fad fa-search"/>
                    </span>
                </Button>
                {showSearch &&
                    <div className="search-div">
                        <input 
                            placeholder={"Search Products...."}
                            onChange={handleSearch}
                            className="product-search"
                        />
                        {" "}
                        {userPermissions && userPermissions[MANAGER_SEARCH_OVERRIDES_MODULE_ID] &&
                            <Button as="a" size="sm" className="btn-category search-btn" onClick={()=>setShowManagerSettings(!showManagerSettings)} >
                                <i className="fas fa-user-cog" />
                            </Button>
                        }
                        {showManagerSettings &&
                            <div className="manager-settings">
                                <p>
                                    <input name="override-status" type="checkbox" onClick={(e)=>handleCheckmark(e, "status")} /> {" "}
                                    <label htmlFor="override-status">Override Status</label>
                                </p>
                                <p>
                                    <input name="override-categories" type="checkbox" onClick={(e)=>handleCheckmark(e, "cats")} /> {" "}
                                    <label htmlFor="override-categories">Override Categories</label>
                                </p>
                            </div>

                        }
                    </div>
                }
                {categories && categories?.length === 1 && !categories[0]?.children?.length && categories?.map((item,i)=> (
                    <Button as="a" size="sm" variant={+activeCategory===+item.id?"primary":"secondary"} data-cy="btn-category" className="btn-category" key={item.id+"-"+i} onClick={()=>categoryClickHandler(item.id)}>
                        All 
                    </Button>    
                ))}
                {((categories && categories?.length > 1) || (categories?.length === 1 && categories[0]?.children?.length > 0)) && firstCat &&
                    <Button as="a" size="sm" variant={(!activeCategory || activeCategory===-1)?"primary":"secondary"} data-cy="btn-category-all" className="btn-category" onClick={()=>categoryClickHandler(0)}>
                        All Categories
                    </Button>
                }
                {categories && categories?.length > 1 && categories?.map((item,i)=> (
                    <Button as="a" size="sm" variant={+activeCategory===+item.id?"primary":"secondary"} data-cy="btn-category" className="btn-category" key={item.id+"-"+i} onClick={()=>categoryClickHandler(item.id)}>
                        {item.name}
                    </Button>
                ))}
            </div>
            {subCategories?.length>0 &&
                <div className="category-buttons subcategory">
                    <br />
                    <div className="subcategory-marker"><i className="far fa-angle-right"></i></div>
                    {subCategories?.map((item,i)=> (
                        <Button as="a" size="sm" variant={+activeCategory===+item.id?"primary":"secondary"} data-cy="btn-category-sub" className="btn-category" key={item.id+"-"+i} onClick={()=>categoryClickHandler(item.id, true)}>
                            {item.name}
                        </Button>
                    ))}
                </div>
            }
        </>
    );
}